module.exports = __webpack_public_path__ + "img/authenticatePage.efb2caf0.png";